import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-86f19066")
const _hoisted_1 = {
  class: "object__files",
  ref: "fileContainer"
}
const _hoisted_2 = ["id", "href", "width", "height"]
const _hoisted_3 = ["id", "href"]
const _hoisted_4 = { id: "close" }
const _hoisted_5 = ["transform"]
const _hoisted_6 = { id: "annotation-controls" }
const _hoisted_7 = ["cx", "cy"]
const _hoisted_8 = ["cx", "cy"]
const _hoisted_9 = { id: "annotation-mask" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("rect", {
  height: "100%",
  width: "100%",
  fill: "#fff"
}, null, -1)
const _hoisted_11 = ["cx", "cy", "r"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("use", {
  href: "#annotation-controls",
  fill: "#000"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("use", {
  href: "#close",
  fill: "#fff"
}, null, -1)
const _hoisted_14 = { id: "annotation-idk" }
const _hoisted_15 = ["cx", "cy", "r"]
const _hoisted_16 = ["cx", "cy", "r"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("use", {
  href: "#annotation-controls",
  fill: "#fff"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("use", {
  href: "#close",
  fill: "#000"
}, null, -1)
const _hoisted_19 = {
  "mask-type": "alpha",
  id: "annotation-alpha-mask"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["cx", "cy", "r"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("rect", {
  height: "100%",
  width: "100%",
  class: "mask",
  mask: "url('#annotation-alpha-mask')",
  fill: "#000",
  opacity: ".7"
}, null, -1)
const _hoisted_26 = { filter: "url(#filter-2)" }
const _hoisted_27 = ["cx", "cy", "r"]
const _hoisted_28 = {
  fill: "#fff",
  opacity: ".7"
}
const _hoisted_29 = ["cx", "cy", "r"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Klik hier om deze persoon toe te voegen")
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "object__details" }
const _hoisted_33 = { class: "box" }
const _hoisted_34 = { class: "box" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Beschrijving", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, "Schrijf hieronder zoveel mogelijk informatie over de foto (denk hierbij aan de (vermoedelijke) datum of tenminste een periode waarop de foto gemaakt is, de locatie (plaatsnaam, adres, etc.) (achtergrond)informatie over de foto, etc.).", -1)
const _hoisted_37 = { style: {"display":"flex","align-items":"center","margin-top":"16px"} }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button is-green"
}, "Opslaan", -1)
const _hoisted_39 = { style: {"margin-left":"16px"} }
const _hoisted_40 = { class: "box" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Personen", -1)
const _hoisted_42 = {
  key: 0,
  class: "persons"
}
const _hoisted_43 = { class: "person__photo" }
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "person__content" }
const _hoisted_46 = { class: "person__name" }
const _hoisted_47 = { class: "person__details" }
const _hoisted_48 = {
  key: 0,
  class: "person__detail"
}
const _hoisted_49 = { class: "person__actions" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "persons is-zero-state"
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "box" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Klaar?", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", null, "Markeer de foto als klaar door hieronder een vinkje te zetten, hierdoor zie je in de overzichtspagina van de collectie welke foto's al klaar zijn.", -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Deze foto is klaar ")
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h1", null, "Bevestigen", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, "Weet je zeker dat je deze persoon van de foto wil verwijderen?", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_enlarge = _resolveComponent("v-enlarge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_layout_default = _resolveComponent("v-layout-default")!
  const _component_v_add_person_dialog = _resolveComponent("v-add-person-dialog")!
  const _component_v_confirm_dialog = _resolveComponent("v-confirm-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_layout_default, null, {
      default: _withCtx(() => [
        _createElementVNode("main", {
          class: _normalizeClass(["object is-photo", [ `is-${_ctx.getObjectOrientation()}` ]])
        }, [
          _createElementVNode("figure", _hoisted_1, [
            (_ctx.flags.isEnlarged)
              ? (_openBlock(), _createBlock(_component_v_enlarge, {
                  key: 0,
                  photoPosition: _ctx.currentPhotoPosition,
                  scaleFactor: _ctx.getScaleFactor(_ctx.object.files[0]),
                  file: _ctx.object.files[0],
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.flags.isEnlarged = false))
                }, null, 8, ["photoPosition", "scaleFactor", "file"]))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.object.files, (file) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: "object__file",
                      style: _normalizeStyle({ width: `${_ctx.scale(file, file.width)}px`, height: `${_ctx.scale(file, file.height)}px` }),
                      ref: "photo",
                      onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAnnotationMoveStart && _ctx.onAnnotationMoveStart(...args))),
                      onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAnnotationMove && _ctx.onAnnotationMove(...args))),
                      onMouseup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onAnnotationMoveEnd && _ctx.onAnnotationMoveEnd(...args)))
                    }, [
                      _createElementVNode("defs", null, [
                        _createElementVNode("image", {
                          id: `file[${file.id}]`,
                          href: _ctx.getUrlForFile(file),
                          width: _ctx.scale(file, file.width),
                          height: _ctx.scale(file, file.height)
                        }, null, 8, _hoisted_2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations, (annotation) => {
                          return (_openBlock(), _createElementBlock("image", _mergeProps({
                            id: `annotation[${annotation.id}]`,
                            href: _ctx.getUrlForFile(file)
                          }, _ctx.getAnnotationParameters(file, annotation)), null, 16, _hoisted_3))
                        }), 256)),
                        _createElementVNode("g", _hoisted_4, [
                          (!_ctx.flags.isEdittingAnnotation)
                            ? (_openBlock(), _createElementBlock("polygon", {
                                key: 0,
                                points: "7 0.705 6.295 0 3.5 2.795 0.705 0 0 0.705 2.795 3.5 0 6.295 0.705 7 3.5 4.205 6.295 7 7 6.295 4.205 3.5",
                                transform: `translate(${_ctx.scale(file, _ctx.annotation.x - _ctx.annotation.radius) - 7 / 2}, ${_ctx.scale(file, _ctx.annotation.y) - 7 / 2})`
                              }, null, 8, _hoisted_5))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("g", _hoisted_6, [
                          (!_ctx.flags.isEdittingAnnotation)
                            ? (_openBlock(), _createElementBlock("circle", {
                                key: 0,
                                r: "8",
                                cx: _ctx.scale(file, _ctx.annotation.x - _ctx.annotation.radius) + (1 / 2),
                                cy: _ctx.scale(file, _ctx.annotation.y)
                              }, null, 8, _hoisted_7))
                            : _createCommentVNode("", true),
                          (_ctx.flags.isAnnotating && !_ctx.flags.annotation.isLocked)
                            ? (_openBlock(), _createElementBlock("circle", {
                                key: 1,
                                r: "8",
                                cx: _ctx.scale(file, _ctx.annotation.x + _ctx.annotation.radius) - (1 / 2),
                                cy: _ctx.scale(file, _ctx.annotation.y)
                              }, null, 8, _hoisted_8))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("mask", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("circle", {
                            fill: "#000",
                            cx: _ctx.scale(file, _ctx.annotation.x),
                            cy: _ctx.scale(file, _ctx.annotation.y),
                            r: _ctx.scale(file, _ctx.annotation.radius)
                          }, null, 8, _hoisted_11),
                          _hoisted_12,
                          _hoisted_13
                        ]),
                        _createElementVNode("mask", _hoisted_14, [
                          _createElementVNode("circle", {
                            fill: "#fff",
                            cx: _ctx.scale(file, _ctx.annotation.x),
                            cy: _ctx.scale(file, _ctx.annotation.y),
                            r: _ctx.scale(file, _ctx.annotation.radius)
                          }, null, 8, _hoisted_15),
                          _createElementVNode("circle", {
                            fill: "#000",
                            cx: _ctx.scale(file, _ctx.annotation.x),
                            cy: _ctx.scale(file, _ctx.annotation.y),
                            r: _ctx.scale(file, _ctx.annotation.radius) - 1
                          }, null, 8, _hoisted_16),
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _createElementVNode("mask", _hoisted_19, [
                          _createElementVNode("use", {
                            height: "100%",
                            width: "100%",
                            mask: "url('#annotation-mask')",
                            href: `#file[${file.id}]`
                          }, null, 8, _hoisted_20)
                        ])
                      ]),
                      _createElementVNode("use", {
                        href: `#file[${file.id}]`
                      }, null, 8, _hoisted_21),
                      (!_ctx.flags.isAnnotating)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations, (annotation) => {
                              return (_openBlock(), _createElementBlock("circle", {
                                class: "face",
                                cx: _ctx.scale(file, annotation.data.x),
                                cy: _ctx.scale(file, annotation.data.y),
                                r: _ctx.scale(file, annotation.data.radius)
                              }, null, 8, _hoisted_23))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.flags.isAnnotating)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("g", _hoisted_26, [
                              _createElementVNode("circle", {
                                mask: "url('#annotation-idk')",
                                cx: _ctx.scale(file, _ctx.annotation.x),
                                cy: _ctx.scale(file, _ctx.annotation.y),
                                r: _ctx.scale(file, _ctx.annotation.radius) + 50
                              }, null, 8, _hoisted_27)
                            ]),
                            _createElementVNode("g", _hoisted_28, [
                              _createElementVNode("circle", {
                                mask: "url('#annotation-idk')",
                                cx: _ctx.scale(file, _ctx.annotation.x),
                                cy: _ctx.scale(file, _ctx.annotation.y),
                                r: _ctx.scale(file, _ctx.annotation.radius) + 50
                              }, null, 8, _hoisted_29)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 36)),
                    _createElementVNode("div", {
                      style: _normalizeStyle([{"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)","pointer-events":"none"}, { width: `${_ctx.scale(file, file.width)}px`, height: `${_ctx.scale(file, file.height)}px` }])
                    }, [
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", {
                            class: "annotation__actions",
                            style: _normalizeStyle([{"position":"absolute"}, _ctx.styling.annotation.target])
                          }, [
                            _createElementVNode("span", {
                              class: "annotation__target",
                              ref: "annotationTarget",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.flags.finishAnnotation = true))
                            }, [
                              (!_ctx.flags.isEdittingAnnotation)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_30
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.edittingAnnotation.data.person.nickname || _ctx.edittingAnnotation.data.person.firstNames) + " " + _toDisplayString(_ctx.edittingAnnotation.data.person.lastName) + _toDisplayString(_ctx.edittingAnnotation.data.person.maidenName && _ctx.edittingAnnotation.data.person.maidenName.length > 0 ? `-${_ctx.edittingAnnotation.data.person.maidenName}` : ''), 1)
                                  ], 64))
                            ], 512),
                            (_ctx.flags.isEdittingAnnotation)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createElementVNode("button", {
                                    class: "annotation__action is-accept",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmAnnotationEdit && _ctx.confirmAnnotationEdit(...args)), ["prevent"])),
                                    title: "Wijzigingen opslaan"
                                  }, "Opslaan"),
                                  _createElementVNode("button", {
                                    class: "annotation__action is-reject",
                                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelAnnotationEdit && _ctx.cancelAnnotationEdit(...args)), ["prevent"])),
                                    title: "Wijzigingen ongedaan maken"
                                  }, "Annuleren")
                                ]))
                              : _createCommentVNode("", true)
                          ], 4), [
                            [_vShow, _ctx.flags.isAnnotating && !_ctx.flags.annotation.isMoving && !_ctx.flags.annotation.isLocked && !_ctx.flags.annotation.finishAnnotation]
                          ])
                        ]),
                        _: 1
                      })
                    ], 4)
                  ], 64))
                }), 256))
              : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("aside", _hoisted_32, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("section", _hoisted_33, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "button is-green",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.flags.isEnlarged = true), ["prevent"]))
                    }, "Uitvergroten")
                  ]),
                  _createElementVNode("section", _hoisted_34, [
                    _hoisted_35,
                    _hoisted_36,
                    _createElementVNode("form", {
                      novalidate: "",
                      autocomplete: "off",
                      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDescriptionSubmit && _ctx.onDescriptionSubmit(...args)), ["prevent"]))
                    }, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "control",
                        style: {"width":"100%","min-height":"200px"},
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.description = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.description]
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createVNode(_Transition, { name: "fade" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("span", _hoisted_39, "Opgeslagen", 512), [
                              [_vShow, _ctx.descriptionSaved]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ], 32)
                  ]),
                  _createElementVNode("section", _hoisted_40, [
                    _hoisted_41,
                    (_ctx.annotations.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations, (annotation) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              to: { name: 'persons.single', params: { personId: annotation.data.person.id } },
                              class: "person"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_43, [
                                  (_openBlock(), _createElementBlock("svg", null, [
                                    _createElementVNode("use", {
                                      href: `#annotation[${annotation.id}]`,
                                      height: "48",
                                      width: "48"
                                    }, null, 8, _hoisted_44)
                                  ]))
                                ]),
                                _createElementVNode("span", _hoisted_45, [
                                  _createElementVNode("span", _hoisted_46, _toDisplayString(annotation.data.person.nickname || annotation.data.person.firstNames) + " " + _toDisplayString(annotation.data.person.lastName) + _toDisplayString(annotation.data.person.maidenName && annotation.data.person.maidenName.length > 0 ? `-${annotation.data.person.maidenName}` : ''), 1),
                                  _createElementVNode("span", _hoisted_47, [
                                    (annotation.data.person.bornAt && annotation.data.person.bornAt.length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.showDate(annotation.data.person.bornAt)), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_49, [
                                  _createElementVNode("button", {
                                    class: "person__action is-edit",
                                    title: "Persoon bijwerken",
                                    onClick: _withModifiers(($event: any) => (_ctx.onEditAnnotationClick(annotation)), ["prevent"])
                                  }, "Aanpassen", 8, _hoisted_50),
                                  _createElementVNode("button", {
                                    class: "person__action is-delete",
                                    title: "Persoon verwijderen",
                                    onClick: _withModifiers(($event: any) => (_ctx.onDeleteAnnotationClick(annotation)), ["prevent"])
                                  }, "Verwijderen", 8, _hoisted_51)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 256))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_52, " Er zijn nog geen personen toegevoegd aan deze foto. ")),
                    _createElementVNode("button", {
                      class: "button is-green",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addAnnotation && _ctx.addAnnotation(...args)), ["prevent"])),
                      disabled: _ctx.flags.isAnnotating
                    }, "Persoon toevoegen", 8, _hoisted_53)
                  ]),
                  _createElementVNode("section", _hoisted_54, [
                    _hoisted_55,
                    _hoisted_56,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.objectDone = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.objectDone]
                      ]),
                      _hoisted_57
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _: 1
    }),
    (_ctx.flags.finishAnnotation)
      ? (_openBlock(), _createBlock(_component_v_add_person_dialog, {
          key: 0,
          onFound: _ctx.onPersonFound,
          onCancel: _ctx.onAddPersonCancel
        }, null, 8, ["onFound", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.flags.confirmAnnotationDelete)
      ? (_openBlock(), _createBlock(_component_v_confirm_dialog, {
          key: 1,
          onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.flags.confirmAnnotationDelete = false))
        }, {
          actions: _withCtx(() => [
            _createElementVNode("button", {
              class: "button is-red",
              onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDeleteAnnotation && _ctx.onDeleteAnnotation(...args)), ["prevent"]))
            }, "Ja, verwijderen"),
            _createElementVNode("button", {
              class: "button is-gray",
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.flags.confirmAnnotationDelete = false), ["prevent"]))
            }, "Nee, annuleren")
          ]),
          default: _withCtx(() => [
            _hoisted_58,
            _hoisted_59
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}